import { PATHS } from '@/config/paths';
import { REPORT_META_BY_CODE } from '@/features/reports/config/reportMeta';
import type { ReportCode } from '@/features/reports/types/report.types';

import type { MenuTreeNode } from '../types/menu.types';

/** Mục Vận hành có mã cố định (không thuộc {@link REPORT_META_BY_CODE}). */
const OPS_EXTRA_SIDEBAR_LABELS: Readonly<Record<string, string>> = {
  'ops.permission_matrix': 'Phân quyền',
  'ops.reports': 'Báo cáo',
};

function normalizePath(p: string | null | undefined): string {
  return (p ?? '').trim().replace(/\/+$/, '') || '/';
}

/**
 * Nhãn hiển thị sidebar Vận hành: ưu tiên bản rút gọn theo `code` (báo cáo + mục đã biết),
 * giữ `node.label` từ API khi không khớp (tùy cấu hình máy chủ).
 */
export function getOpsSidebarLabel(node: MenuTreeNode): string {
  const report = REPORT_META_BY_CODE.get(node.code as ReportCode);
  if (report) return report.shortTitle;

  const byCode = OPS_EXTRA_SIDEBAR_LABELS[node.code];
  if (byCode) return byCode;

  const path = normalizePath(node.path);
  if (path === normalizePath(PATHS.OPS_REPORTS) && (node.children?.length ?? 0) > 0) {
    return 'Báo cáo';
  }

  return node.label;
}
